import { css } from '@emotion/css';

const styles = {
  container: css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: linear-gradient(to bottom, #ffffff, #dfe1e7);
    padding: 16px 42px;
    row-gap: 16px;
  `,
  button: css`
    text-transform: none !important;
  `,
  icon: css`
    position: absolute;
    right: -20px;
    bottom: 0;
  `,
};

export default styles;
